jQuery(function() {
    loadHeader();
    loadCustomForms();
    loadPopups();
    loadScrollHidden();
    loadCheckout();
    loadFilteredProducts();
    loadAddToCardEvent();
})

const loadHeader = () => {
    import(/* webpackChunkName: "header" */ '../modules/header/index')
      .then(({ default: header }) => {
          header();
      })
      .catch(error => console.error('Error loading header module:', error));
};

const loadCheckout = () => {
    import(/* webpackChunkName: "checkout" */ '../modules/checkoutModule')
      .then(({ default: checkout }) => {
          checkout();
      })
      .catch(error => console.error('Error loading checkout module:', error));
};

const loadCustomForms = () => {
    import(/* webpackChunkName: "custom-forms" */ '../modules/initCustomForms')
      .then(({ default: initCustomForms }) => {
          initCustomForms();
      })
      .catch(error => console.error('Error loading custom forms module:', error));
};

const loadPopups = () => {
    import(/* webpackChunkName: "popups" */ '../modules/initPopups')
      .then(({ default: initPopups }) => {
          initPopups();
      })
      .catch(error => console.error('Error loading popups module:', error));
};

const loadAddToCardEvent = () => {
    import(/* webpackChunkName: "add-to-card" */ '../modules/addToCardEvent')
      .then(({ default: addToCardEventInit }) => {
          addToCardEventInit();
      })
      .catch(error => console.error('Error loading add to card event module:', error));
};

const loadScrollHidden = () => {
    import(/* webpackChunkName: "scroll-hidden" */ '../modules/scrollHidden')
      .then(({ default: scrollHidden }) => {
          scrollHidden();
      })
      .catch(error => console.error('Error loading scroll hidden module:', error));
};

const loadFilteredProducts = () => {
    import(/* webpackChunkName: "filtered-products" */ '../modules/filter/filteredProducts')
      .then(({ default: filteredProducts }) => {
        const $dataContainer = $('.data-container');
        filteredProducts({
            showCatalog: false,
            showCategory: false,
            updateBrandFilter: true,
            updateGroupFilter: true,
            apiUrl: '/umbraco/api/products/GetPaginatedCategory',
            title: $dataContainer.attr('data-title'),
            metaDescription: $dataContainer.attr('data-meta-description')
        });
      })
      .catch(error => console.error('Error loading filtered products module:', error));
};